let popupTpl = _.template(
  `<div class="Dialog Dialog-parking Dialog-desktopPopup <%- positionClass %>" style="position: absolute; width: 286px; left: <%- x %>px; top: <%- y %>px;">
        <div class="Dialog_head"><%= title %></div>
        <div class="Dialog_content">
            <div class="Dialog_num"></div>
            <dl class="Dialog_dl">
                <dt class="Dialog_dt">Площадь:</dt>
                <dd class="Dialog_dd"><%= area %> м<sup>2</sup></dd>
                <dt class="Dialog_dt">Стоимость:</dt>
                <dd class="Dialog_dd"><%= price.toLocaleString("Ru-ru") %>&nbsp;₽</dd>
            </dl>
            <a href="#Callback" data-fancybox class="Dialog_btn Btn">Оставить заявку</a>
        </div>
    </div>`.replace(/\s{2,}/g, "")
);

let setupSectionHoverBehaviour = () => {
  $(".EstScheme_link").hover(
    (event) => {
      let $item = $(event.currentTarget);
      $item.addClass("EstScheme_link-active");
    },
    (event) => {
      let $item = $(event.currentTarget);
      $item.removeClass("EstScheme_link-active");
    }
  );

  let $scheme = $(".BldScheme");

  let $popup = $(".Dialog-parking");
  $popup.remove();

  $(document).on("click", (event) => {
    const target = event.target;
    const isPopup = $(target).closest(".Dialog-desktopPopup").length > 0;
    const isPopupLink = $(target).closest("[data-params]").length > 0;
    const $popup = $(".Dialog-parking");

    if (!isPopup && !isPopupLink) {
      $popup.remove();
    }
  });

  $scheme.find("[data-params]").on("click", function(e) {
    e.preventDefault();
    let windowCenter = $("body").height() / 2;

    let $el = $(this);
    let params = $el.data("params");

    $("#Callback").find("form").find('input[name="parking_type"]').remove();
    $("#Callback")
      .find("form")
      .append(`<input value="${params.title}" name="parking_type"/>`);

    if (!window.matchMedia("(max-width: 1279px)").matches && $scheme.length) {
      let $popup = $(".Dialog-parking");
      let offset = {
        x: -143,
        y: 0,
      };

      let positionTop = true;

      if (windowCenter > e.pageY) {
        offset.y = 20;
        positionTop = true;
      } else {
        offset.y = -256;
        positionTop = false;
      }

      $("#Callback #frm_flat_type").val("pantry");
      $("#Callback #frm_flat_name").val("#" + params.num);

      $popup.remove();

      $("body").append(
        popupTpl({
          x: e.pageX + offset.x,
          y: e.pageY + offset.y,
          title: params.title,
          area: params.area,
          price: params.price,
          positionClass: positionTop
            ? "Dialog-topPosition"
            : "Dialog-bottomPosition",
        })
      );
    } else {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            $(
              `.HouseSection_mobileCard[flat_id='${$el.attr("flat_id")}']`
            ).offset().top - 15,
        },
        1000
      );
    }
  });

  $(document).on("click", function(e) {
    const currentDevice = window.device.default;
    if (
      !$(e.target).closest(".EstScheme_link").length &&
      !$(e.target).closest(".Dialog").length &&
      currentDevice.desktop()
    ) {
      console.log(!$(e.target).closest(".EstScheme_link"));
      $(".Dialog-parking").remove();
    }
  });
};

$(window).on("load", () => {
  setupSectionHoverBehaviour();
});

$(document).on("click", ".HouseSection_mobileCard > .Btn", function () {
  const title = $(this)
    .closest(".HouseSection_mobileCard")
    .find(".Dialog_head")
    .text();

  $("#Callback").find("form").find('input[name="parking_type"]').remove();
  $("#Callback")
    .find("form")
    .append(`<input value="${title}" name="parking_type"/>`);
});

$("main").on("click", "[data-parking-floors]", (event) => {
  event.preventDefault();
  let currentLink = event.currentTarget;
  let ref = event.currentTarget.href;
  $("[data-parking-floors]").removeClass("_active");
  currentLink.className += " _active";
  let $schemeBlock = $(".HouseSection_schemeScroll");
  let $mobileCardsBlock = $(".HouseSection_mobileCards");
  $schemeBlock.addClass("HouseSection_inner-disabled");
  $.ajax({
    url: ref,
    dataType: "html",
  })
    .done((response) => {
      let $newDoc = $(response);

      let $newSectionInfo = $newDoc.find(".HouseSection_schemeScroll");
      let $newMobileCards = $newDoc.find(".HouseSection_mobileCards");

      $schemeBlock.html($newSectionInfo.html());
      $mobileCardsBlock.html($newMobileCards.html());
      $("#filterForm").submit();
      setupSectionHoverBehaviour();

      let title = $newDoc.filter("title").html();
      document.title = title;
      history.replaceState({}, title, ref);
    })
    .fail(function () {
      alert("Не удалось получить данные о секции!/nПопробуйте позже.");
    })
    .always(function () {
      $schemeBlock.removeClass("HouseSection_inner-disabled");
    });
});
